// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import "fullcalendar/core/main.css";
@import "fullcalendar/daygrid/main.css";

@import "fullcalendar/core/main.css";
@import "fullcalendar/daygrid/main.css"; */

/* min-height, not height: required labels that wrap (long German labels on phones) must grow. */
.ant-form-item-required {
  min-height: 23px;
}

.header-one .header-nav {
  height: 130px !important;
}

.header-one .header-nav .logo img {
  width: 120px !important;
}

.container-fluid {
  background-color: white;
}

.ant-form-item-required::before {
  display: none !important;
}

.ant-form-item-required::after {
  visibility: unset !important;
  display: inline-block !important;
  margin-inline-end: 4px;
  color: var(--ds-danger) !important;
  font-size: 14px !important;
  font-family: SimSun, sans-serif;
  line-height: 1 !important;
  content: "*" !important;
}

/* Icons take the cursor of whatever they sit in (a button or link shows a pointer). The old
   rule forced cursor:default on every icon, and a missing selector prefix made every <i> white. */
.dashboard-user-avatar svg,
.dashboard-user-avatar i {
  color: white;
}

.dark-logo-color {
  color: var(--ds-brand-ink);
}

.suc-color {
  color: var(--ds-success) !important;
}

.eye-color {
  color: lightgrey !important;
}

.edit-delete-dropdown-color {
  color: var(--ds-text-2) !important;
}

.dropdown-menu-padding {
  padding: 0px;
}

.priority {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}

.priority::before {
  display: block;
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.priority.low {
  color: green;
}

.priority.medium {
  color: #ffbc34 !important;
}

.priority.high {
  color: red;
}

.priority.low::before {
  background-color: green !important;
}

.priority.medium::before {
  background-color: #ffbc34 !important;
}

.priority.high::before {
  background-color: red !important;
}

.hideTabsMenu > .ant-tabs-nav {
  display: none !important;
}

.ant-modal-body {
  max-height: 65vh;

  overflow-x: hidden;
  overflow-y: auto;
}

@media print {
  .printHeader {
    display: none !important;
  }

  .header-one.header-fixed {
    display: none !important;
  }
}

.SalarySlipDetails .ant-card-extra {
  margin-inline-start: 0px !important;
  width: 100%;
  position: relative;
}

.SalarySlipDetails .ant-card-extra button {
  position: absolute;
  top: -2px;
  right: -30px;
}

.row > div {
  margin-top: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;0CAI0C;;AAE1C,gGAAgG;AAChG;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,sBAAsB;EACtB,kCAAkC;EAClC,0BAA0B;EAC1B,+BAA+B;EAC/B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;kGACkG;AAClG;;EAEE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;;EAEhB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* @import \"fullcalendar/core/main.css\";\n@import \"fullcalendar/daygrid/main.css\";\n\n@import \"fullcalendar/core/main.css\";\n@import \"fullcalendar/daygrid/main.css\"; */\n\n/* min-height, not height: required labels that wrap (long German labels on phones) must grow. */\n.ant-form-item-required {\n  min-height: 23px;\n}\n\n.header-one .header-nav {\n  height: 130px !important;\n}\n\n.header-one .header-nav .logo img {\n  width: 120px !important;\n}\n\n.container-fluid {\n  background-color: white;\n}\n\n.ant-form-item-required::before {\n  display: none !important;\n}\n\n.ant-form-item-required::after {\n  visibility: unset !important;\n  display: inline-block !important;\n  margin-inline-end: 4px;\n  color: var(--ds-danger) !important;\n  font-size: 14px !important;\n  font-family: SimSun, sans-serif;\n  line-height: 1 !important;\n  content: \"*\" !important;\n}\n\n/* Icons take the cursor of whatever they sit in (a button or link shows a pointer). The old\n   rule forced cursor:default on every icon, and a missing selector prefix made every <i> white. */\n.dashboard-user-avatar svg,\n.dashboard-user-avatar i {\n  color: white;\n}\n\n.dark-logo-color {\n  color: var(--ds-brand-ink);\n}\n\n.suc-color {\n  color: var(--ds-success) !important;\n}\n\n.eye-color {\n  color: lightgrey !important;\n}\n\n.edit-delete-dropdown-color {\n  color: var(--ds-text-2) !important;\n}\n\n.dropdown-menu-padding {\n  padding: 0px;\n}\n\n.priority {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n}\n\n.priority::before {\n  display: block;\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n}\n\n.priority.low {\n  color: green;\n}\n\n.priority.medium {\n  color: #ffbc34 !important;\n}\n\n.priority.high {\n  color: red;\n}\n\n.priority.low::before {\n  background-color: green !important;\n}\n\n.priority.medium::before {\n  background-color: #ffbc34 !important;\n}\n\n.priority.high::before {\n  background-color: red !important;\n}\n\n.hideTabsMenu > .ant-tabs-nav {\n  display: none !important;\n}\n\n.ant-modal-body {\n  max-height: 65vh;\n\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n@media print {\n  .printHeader {\n    display: none !important;\n  }\n\n  .header-one.header-fixed {\n    display: none !important;\n  }\n}\n\n.SalarySlipDetails .ant-card-extra {\n  margin-inline-start: 0px !important;\n  width: 100%;\n  position: relative;\n}\n\n.SalarySlipDetails .ant-card-extra button {\n  position: absolute;\n  top: -2px;\n  right: -30px;\n}\n\n.row > div {\n  margin-top: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
